const ReferIconSVG = ({ className }) => (
    <svg
        className={className}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.25 5.25h-1.2a2.1 2.1 0 0 0 .45-1.3A1.95 1.95 0 0 0 9.6 2.62L9 3.36l-.6-.74A1.95 1.95 0 0 0 4.5 3.95c0 .48.16.93.45 1.3H3.75a1.5 1.5 0 0 0-1.5 1.5V8.1c0 .41.34.75.75.75h.3v5.4a1.5 1.5 0 0 0 1.5 1.5h8.4a1.5 1.5 0 0 0 1.5-1.5v-5.4h.3a.75.75 0 0 0 .75-.75V6.75a1.5 1.5 0 0 0-1.5-1.5ZM10.05 3.4a.6.6 0 1 1 .45.99H9.9c.05-.4.07-.7.15-.99Zm-2.55-.15a.6.6 0 0 1 .6.6c.08.29.1.59.15.99H7.5a.6.6 0 0 1-.6-.99.6.6 0 0 1 .6-.6ZM8.25 14.25H5.25v-5.4h3v5.4Zm0-6.9H3.75V6.75h4.5v.6Zm4.5 6.9H9.75v-5.4h3v5.4Zm1.5-6.9H9.75V6.75h4.5v.6Z"
            fill="currentColor"
        />
    </svg>
);

export default ReferIconSVG;
